import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'

const Root = styled.div`
  width: 100%;
  text-align: center;

  > * + * {
    margin-top: ${rem(16)};
  }

  ${mediaQueryUp.tablet} {
    width: ${rem(640)};
    margin-left: auto;
    margin-right: auto;
  }
`

interface Props extends PropsWithChildren, Utils.PropsWithDataAttributes {
  title: string;
  className?: string;
}

function AwesomeError(props: Props) {
  const { title, children, ...rest } = props

  return (
    <Root {...rest}>
      <Heading variant="heading3" as="h1" align="center">{title}</Heading>
      {children}
    </Root>
  )
}

export default React.memo(AwesomeError)
